import {CSSProperties} from '../../../styleSheet';
import {StyleCategoryName} from '../types';
import {StyleCategoryMap} from './StyleCategoryMap';

export const getStaticDefaultsForStyleCategories = (
  styleCategories: StyleCategoryName[],
): CSSProperties => {
  return styleCategories.reduce((acc, c) => {
    const sf = StyleCategoryMap[c].defaultStyleFactory;
    return sf ? {...acc, ...sf()} : acc;
  }, {});
};
